<div class="section">
  <h3 fxLayoutAlign="center">{{ "licenseagreement.softwarelicenceAgreement" | translate }}</h3>
  <ul>
    <li>
      <p id="note" class="note">{{ "licenseagreement.note" | translate }}</p>
    </li>
    <li>
      <p class="section-name">{{ "licenseagreement.section1" | translate }}</p>
      <ul class="indentback">
        <li>
          {{ "licenseagreement.section1Li1" | translate }}
          <span style="text-decoration: underline">ViSOL </span>
        </li>
        <li>{{ "licenseagreement.section1Li2" | translate }}</li>
        <li>{{ "licenseagreement.section1Li3" | translate }}</li>
      </ul>
    </li>
    <li>
      <p class="section-name">{{ "licenseagreement.section2" | translate }}</p>
      <ul>
        <li>{{ serialNumberLabel }} {{ "licenseagreement.section2Li" | translate }}</li>
      </ul>
    </li>
    <li>
      <p class="section-name">{{ "licenseagreement.section3" | translate }}</p>
      <ul class="indentback">
        <li>{{ "licenseagreement.section3Li1" | translate }}</li>
        <li>{{ "licenseagreement.section3Li2" | translate }}</li>
        <li>{{ "licenseagreement.section3Li3" | translate }}</li>
      </ul>
    </li>
    <li>
      <p class="section-name">{{ "licenseagreement.section4" | translate }}</p>
      <ul class="indentback">
        <li>{{ "licenseagreement.section4Li0" | translate }}</li>
        <li>{{ "licenseagreement.section4Li1" | translate }}</li>
        <li>{{ "licenseagreement.section4Li2" | translate }}</li>
        <li>{{ "licenseagreement.section4Li3" | translate }}</li>
        <li>{{ "licenseagreement.section4Li4" | translate }}</li>
        <li>{{ "licenseagreement.section4Li5" | translate }}</li>
        <li>{{ "licenseagreement.section4Li6" | translate }}</li>
        <li>{{ "licenseagreement.section4Li7" | translate }}</li>
        <li>{{ "licenseagreement.section4Li8" | translate }}</li>
        <li>{{ "licenseagreement.section4Li9" | translate }}</li>
        <li>{{ "licenseagreement.section4Li10" | translate }}</li>
      </ul>
    </li>
    <li>
      <p class="section-name">{{ "licenseagreement.section5" | translate }}</p>
      <ul class="indentback">
        <li>{{ "licenseagreement.section5Li1" | translate }}</li>
        <li>{{ "licenseagreement.section5Li2" | translate }}</li>
      </ul>
    </li>
    <li>
      <p class="section-name">{{ "licenseagreement.section6" | translate }}</p>
      <ul>
        <li>{{ "licenseagreement.section6Li" | translate }}</li>
      </ul>
    </li>
    <li>
      <p class="section-name">{{ "licenseagreement.section7" | translate }}</p>
      <ul>
        <li>{{ "licenseagreement.section7Li" | translate }}</li>
      </ul>
    </li>
    <li>
      <p class="section-name">{{ "licenseagreement.section8" | translate }}</p>
      <ul class="indentback">
        <li>{{ "licenseagreement.section8Li1" | translate }}</li>
        <li>{{ "licenseagreement.section8Li2" | translate }}</li>
        <li>{{ "licenseagreement.section8Li3" | translate }}</li>
      </ul>
    </li>
    <li>
      <p class="section-name">{{ "licenseagreement.section9" | translate }}</p>
      <ul class="indentback">
        <li>{{ "licenseagreement.section9Li1" | translate }}</li>
        <li>{{ "licenseagreement.section9Li2" | translate }}</li>
      </ul>
    </li>
  </ul>
</div>
